import { motion } from "framer-motion";

export default function NeuralBackdrop({ className }) {
  return (
    <div className={`fixed inset-0 z-0 pointer-events-none overflow-hidden bg-void ${className || ''}`}>
      {/* 1. Deep Base */}
      <div className="absolute inset-0 bg-[#050A10]" />

      {/* 2. The Aurora Orbs (Breathing) */}
      <motion.div 
        animate={{ 
          scale: [1, 1.2, 1], 
          opacity: [0.3, 0.5, 0.3], 
          x: [-20, 20, -20] 
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-nilyTeal blur-[120px] opacity-20 mix-blend-screen"
      />
      
      <motion.div 
        animate={{ 
          scale: [1, 1.1, 1], 
          opacity: [0.2, 0.4, 0.2], 
          y: [-50, 50, -50] 
        }}
        transition={{ duration: 15, repeat: Infinity, ease: "easeInOut", delay: 2 }}
        className="absolute bottom-[-10%] right-[-10%] w-[60vw] h-[60vw] rounded-full bg-neurovaPurple blur-[140px] opacity-10 mix-blend-screen"
      />

      {/* 3. The Noise Texture */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />
    </div>
  );
}
